<div class="xplot-controls omit-from-screenshot">
  <span class="ctl-label">Y</span>
  <app-segy-field-select
    class="axis-select"
    [options]="fieldOptions()"
    [value]="yField()"
    (valueChange)="yField.set($any($event))"
  ></app-segy-field-select>
  <span class="ctl-label">against X</span>
  <app-segy-field-select
    class="axis-select"
    [options]="fieldOptions()"
    [extraOptions]="traceOption"
    [value]="xField()"
    (valueChange)="xField.set($any($event))"
  ></app-segy-field-select>
  <span class="ctl-label">Colour by</span>
  <app-segy-field-select
    class="axis-select"
    placeholder="none"
    [allowClear]="true"
    [options]="fieldOptions()"
    [extraOptions]="traceOption"
    [value]="colorField()"
    (valueChange)="colorField.set($any($event) ?? null)"
  ></app-segy-field-select>
</div>

@if (options(); as opts) {
  <div echarts class="xplot-chart" [options]="opts"></div>
} @else {
  <div class="xplot-empty">Loading the chosen fields…</div>
}
